import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import AdminPage from "@/pages/AdminPage";

const SITE_TITLE = "Alba Immobili — Agenzia Immobiliare a Milano";

function App() {
  useEffect(() => {
    const applyBranding = () => {
      if (document.title !== SITE_TITLE) document.title = SITE_TITLE;
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      const href = "/favicon-512.png";
      if (!link.href.endsWith(href)) link.href = href;
    };
    applyBranding();
    const id = setInterval(applyBranding, 1000);
    const stop = setTimeout(() => clearInterval(id), 6000);
    return () => { clearInterval(id); clearTimeout(stop); };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
